import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 600px;
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
  background: var(--glass-1);
  padding: 30px;
  border-radius: var(--radius, 16px);
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
`;

const Title = styled.h2`
  color: var(--text-primary);
  margin: 0 0 20px 0;
  font-size: 24px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-bottom: 15px;

  @media(max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  color: #fff;
  outline: none;
`;

const CheckboxWrap = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 20px;
  cursor: pointer;
`;

const Button = styled.button`
  width: 100%;
  padding: 14px;
  border-radius: 8px;
  background: var(--accent);
  color: #fff;
  font-weight: bold;
  border: none;
  cursor: pointer;
`;

const RegisterWidget = ({ node }) => {
  return (
    <Wrapper align={node.style?.desktop?.align || 'center'} width={node.style?.desktop?.width}>
      <Title>{node.content?.title || 'Account erstellen'}</Title>
      <form onSubmit={e => e.preventDefault()}>
        <Grid>
          <Input type="text" placeholder="Vorname" />
          <Input type="text" placeholder="Nachname" />
        </Grid>
        <Input type="email" placeholder="E-Mail Adresse" style={{marginBottom: 15}} />
        <Input type="password" placeholder="Passwort" style={{marginBottom: 15}} />
        <Input type="password" placeholder="Passwort wiederholen" style={{marginBottom: 15}} />
        
        <CheckboxWrap>
          <input type="checkbox" />
          <span>Ich stimme den AGB und den Datenschutzbestimmungen zu.</span>
        </CheckboxWrap>

        <Button className="tef-bubbles">{node.content?.btnText || 'Jetzt registrieren'}</Button>
      </form>
    </Wrapper>
  );
};

registry.register('register_form', {
  label: 'Registrierung Box',
  icon: '📝',
  category: 'forms',
  defaultContent: { title: 'Neuen Account erstellen', btnText: 'Registrieren' },
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: RegisterWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Texte', fields: [{name:'content.title', label:'Titel', type:'text'}, {name:'content.btnText', label:'Button', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Alignment', type:'select', options:[{label:'Links', value:'left'}, {label:'Zentriert', value:'center'}]}] }] }
  ]
});
